/* eslint-disable no-param-reassign */
import ContentService, { generateImageUrl } from '../../assets/js/amplience-content-service';

export const makeImage = content => ({
  type: 'image',
  url: generateImageUrl(content.image),
  altText: content.imageAltText,
  link: content.link
});

export default class ImageContentService extends ContentService {
  formatImageContent() {
    return this.getContent().then((formatted) => {
      this.content = makeImage(formatted);
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/image/image-content.js